export default __webpack_public_path__ + "static/google-reviews-3c21f14436f53cf2ebadbaba41bd3737.svg";